import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import LogoSP from '../Logos/LogoSP'
import LogoCP from '../Logos/LogoPortfolio'
import Stack from '@mui/material/Stack'
import Dialog from '../Dialog'
import Projects from '../Projects'
import useStore from '../Store';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from '@mui/material/Link'


const logo = [<LogoSP/>, <LogoCP/>]

const AboutShare = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  return(
    <Stack sx={{height: isMobile?'310px':'310px', overflow: 'scroll', paddingTop: '20px'}} spacing={2}>
    <Typography variant='body1' color='default'>
     We develop and build high-quality properties in the German speaking region.
     Technology, sustainability and passion is our cornerstone with timber as the fundamental building component.
     Our team’s instruments include the latest planning and manufacturing technologies.
      With a single goal; to create cost efficient and ecologically engaging, vibrant living spaces for you and the generations to come.
    </Typography>
    <Link href="https://www.swiss-property.ch/en/">  www.swiss-property.ch</Link>
  </Stack>
  )
}

const LeftSide = ({onGoToLocation}) => {
  const {portfolios, portfolioNumber} = useStore();
  return(
    <Stack
    direction='row'
    alignItems="center"
    spacing={1}
    sx={{marginLeft:'-8px'}}
    >
        <Dialog
            iconButton={true}
            labelBold={false}
            buttonLabel='SP Portfolio'
            tabs={false}
            icon={logo[portfolioNumber]}
            dialogTitle={
            <Stack
            alignItems={'center'}
            justifyContent={'center'}
            direction='row'
            spacing={1}
            >
                <Typography variant={'body1'} color='primary'>
                Swiss Property
                </Typography>
              </Stack>
            }
            dialogContent={
              <AboutShare/>
            }
          />
      <Dialog
        actionTitle={'OK'}
        buttonLabel={'Projects'}
        buttonColor={'primary'}
        tabs={false}
        tabList={['Recent']}
        dialogTitle={
          <Typography>
            Projects
          </Typography>
        }
        dialogContent={
          <Projects onGoToLocation={onGoToLocation}/>
        }
      />
    </Stack>
    )
  }

  export default LeftSide
